import { Box, BoxProps, Flex, Text, VisuallyHidden } from '@chakra-ui/react';
import * as React from 'react';
import { FC } from 'react';
import NextLink from 'next/link';
import { Logo } from './Logo';
import { NavContent } from './navBar/NavContent';

interface NavbarProps extends BoxProps {}

export const Navbar: FC<NavbarProps> = (props) => (
  <Box _dark={{ color: 'secondary.900' }} {...props}>
    <Box as='header' height='16' position='relative' zIndex='sticky' maxW='8xl' mx='auto'>
      <Box height='100%' mx='auto' ps={{ base: '6', md: '0' }} pe={{ base: '5', md: '0' }}>
        <Flex as='nav' aria-label='Site1 navigation' align='center' justify='space-between' height='100%'>
          <Box rel='home'>
            <NextLink href='/'>
              <Flex direction='column' alignItems='flex-start'>
                <Logo height={16} />
                <Text fontSize='xs' fontWeight='light' color='accent-alt' mt='-1' lineHeight='1' ml={5}>
                  Powered by VAT IT
                </Text>
              </Flex>
              <VisuallyHidden>eezi</VisuallyHidden>
            </NextLink>
          </Box>
          <NavContent.Desktop display={{ base: 'none', md: 'flex' }} />
          <NavContent.Mobile display={{ base: 'flex', md: 'none' }} />
        </Flex>
      </Box>
    </Box>
  </Box>
);
